var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#2165B6;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.2061,
    y1: -0.02779578,
    x2: 1.2196,
    y2: -0.02779578,
    gradientTransform: "matrix(136.0596 99.8487 -151.8774 89.4496 194.2193 197.3453)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9CBCE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7B7A81"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.4,325.4c-76,0-140.7-38.1-140.7-83.7s57-83.6,133.1-83.6c96,0,140.5,36.9,140.5,82.6 C413.4,286.3,364.3,325.4,280.4,325.4 M250,112.5c-98.9,0-182.5,53.2-182.5,121.7c0,64.6,83.1,118.3,182,118.3 c98.9,0,183-49.9,183-118.3S348.9,112.5,250,112.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st1",
    d: "M218.6,186.4v201.2h60.8v-78.2c15.2,0,24.3-3.3,34.2,14.9c15.2,26.1,34.2,63.3,34.2,63.3H420 c0,0-45.6-74.5-49.4-78.2c-7-7.5-15.2-7.5-26.6-11.2c22.8-3.7,44.1-13.2,51.4-33.5c6.5-18.6,5.7-42.3-8.1-58.2 c-12-12.6-24.3-20.1-54.7-20.1H218.6z M279.4,228.3h39.9c9.5,0,17.1,9.3,17.1,18.6c0,9.3-7.6,18.6-17.1,18.6h-39.9V228.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/r.83af4f94711912c3d8fe3b680aed9885.svg";
export { ForwardRef as ReactComponent };